import { render, staticRenderFns } from "./BaseEditorSms.vue?vue&type=template&id=a3cc8b0c&scoped=true&"
import script from "./BaseEditorSms.vue?vue&type=script&lang=js&"
export * from "./BaseEditorSms.vue?vue&type=script&lang=js&"
import style0 from "./BaseEditorSms.vue?vue&type=style&index=0&id=a3cc8b0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cc8b0c",
  null
  
)

export default component.exports